
import React from 'react';
import { Button } from '@/components/ui/button';
import { Copy, Check } from 'lucide-react';

export interface CopyLinkButtonProps {
  onCopy: () => void;
  isCopied: boolean;
}

const CopyLinkButton: React.FC<CopyLinkButtonProps> = ({ onCopy, isCopied }) => {
  return (
    <Button
      onClick={onCopy}
      variant="outline"
      className="w-full mt-2 justify-center border-dashed h-9"
      size="sm"
      disabled={isCopied}
    >
      {isCopied ? (
        <>
          <Check className="h-3.5 w-3.5 mr-2" />
          Link kopiert
        </>
      ) : (
        <>
          <Copy className="h-3.5 w-3.5 mr-2" />
          Link kopieren
        </>
      )}
    </Button>
  );
};

export default CopyLinkButton;
